/* eslint-disable react/jsx-no-useless-fragment */
import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'

// Components
import PageWrapper from 'components/PageWrapper'
import { MeContext } from 'contexts/me'
import { trackEvent } from 'analytics/trackFunctions'
import { hasActiveMembership, hasSuspendedMembership } from 'utils'
import InactiveMembership from './InactiveMembership'

import ActiveMembership from './ActiveMembership'

const Membership = () => {
  const { me } = useContext(MeContext)

  const { origin } = useParams()

  const title = {
    membership: (
      <span>
        Mi Wayni<span className='text-green-800 font-bold'>+</span>
      </span>
    ),
    hasNotMembership: (
      <span>
        Sumate a Wayni<span className='text-green-800 font-bold'>+</span>
      </span>
    )
  }

  useEffect(() => {
    trackEvent({
      eventName: hasActiveMembership(me?.subscriber_products)
        ? 'bille_wayniplus_suscripcion'
        : 'bille_wayniplus_beneficios'
    })
  }, [])

  if (!me) return ''

  return (
    <PageWrapper
      noTabBar
      title={
        hasActiveMembership(me?.subscriber_products)
          ? title.membership
          : title.hasNotMembership
      }
      viewSelected='/suscripcion'
    >
      <section className='flex flex-col text-black lg:flex-row justify-center items-center max-w-564 md:max-w-4xl lg:max-w-5xl mx-auto'>
        {hasActiveMembership(me?.subscriber_products) ? (
          <ActiveMembership />
        ) : (
          <InactiveMembership
            suspendedMembership={hasSuspendedMembership(
              me?.subscriber_products
            )}
            origin={origin}
          />
        )}
      </section>
    </PageWrapper>
  )
}

export default Membership
